import * as Sentry from '@sentry/angular';

import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router, RouteReuseStrategy } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { TranslocoRootModule } from './core/translation/transloco-root.module';
import { UIModule } from './ui/ui.module';
import { CurrencyPipe } from '@angular/common';
import { TranslationService } from './core/services/translation/translation.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { DemoInterceptor } from './core/interceptors/demo.interceptor';
import { environment } from 'src/environments/environment';
import { AppHeaderComponent } from './features/app-header/app-header.component';
import { GameScoreComponent } from './features/app-header/game-score/game-score.component';
import { PipeModule } from './core/pipes/pipes.module';
import { NavbarComponent } from './features/app-header/navbar/navbar.component';
import { SpinnersModule } from './features/spinners/spinners.module';
import { FirebaseService } from './core/services/firebase/firebase.service';

export function initializeTranslation(translationService: TranslationService) {
  return () => translationService.preloadLanguage();
}

Sentry.init({
  dsn: 'https://9d97bac2087f3ed9eaca8c98b45c6a42@o4508852223737856.ingest.us.sentry.io/4509207356506112',
  release: `widget@${environment.version}`,
  environment: environment.production ? 'production' : 'sandbox',
  dist: `${environment.build}`,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: environment.production ? 0.05 : 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/play\.clinch\.gg\//],
  debug: false,
});

@NgModule({
  declarations: [AppComponent, AppHeaderComponent, NavbarComponent, GameScoreComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      rippleEffect: true,
      mode: 'md',
    }),
    IonicStorageModule.forRoot(),
    AppRoutingModule,
    UIModule,
    HttpClientModule,
    TranslateModule.forRoot(),
    TranslocoRootModule,
    BrowserAnimationsModule,
    SpinnersModule,
    PipeModule,
  ],
  providers: [
    FirebaseService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    TranslationService,
    CurrencyPipe,
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTranslation,
      deps: [TranslationService, Sentry.TraceService],
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DemoInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private firebaseService: FirebaseService) {}
}
